import React, { ComponentProps } from "react";

import { StrainV2 } from "@/custom-types/StrainV2";
import { useEventTracker } from "@/hooks/useEventTracker";

import Button from "@/components/botanic/Button";
import TrackImpression from "@/components/TrackImpression";

const ShopStrainButton: React.FC<{
  strain: StrainV2;
  width?: ComponentProps<typeof Button>["width"];
}> = ({ strain, width }) => {
  const { publishEvent } = useEventTracker();
  const strainId = strain.id;

  return (
    <TrackImpression
      trackingFunction={() => {
        publishEvent({
          action: "impression",
          category: "button",
          label: "shop strain",
          strainId,
        });
      }}
    >
      <Button
        width={width}
        href="#strain-shopping"
        data-testid="strain-shop-button"
        onClick={() => {
          publishEvent({
            action: "click",
            category: "button",
            label: "shop strain",
            strainId,
          });
        }}
      >
        shop {strain.name}
      </Button>
    </TrackImpression>
  );
};

export default ShopStrainButton;
